import { Button } from '@material-ui/core';
import { observer } from 'mobx-react';
import * as React from 'react';

import { ResetConfirmContainer } from '../reset-confirm';

import styles from './reset-confirm.less';

interface Props {
    container: ResetConfirmContainer;
}

export const ResetConfirm: React.SFC<Props> = observer(
    ({ container: { email, handleSubmit, isBusy } }) => (
        <div className="page page-inverted login-image-background">
            <div className="card">
                <h1>Password updated</h1>
                <div className="card-content centered-content">
                    <p>The password for {email} has been reset.</p>
                    <img
                        className={styles.img}
                        src="/assets/images/mountain.png"
                        srcSet="/assets/images/mountain.png, /assets/images/mountain@2x.png 2x, /assets/images/mountain@3x.png 3x"
                    />
                </div>

                <div className="space-filler" />
                <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="next-step-button"
                    onClick={handleSubmit}
                    disabled={isBusy}
                >
                    Click here to log in
                </Button>
                <div id="recaptcha-div" />
            </div>
        </div>
    )
);
